import React, { useMemo } from "react";

import Design from "../../../../../../features/countdown/components/designs/Design";
import {
  CountdownTemplatesContainer,
  DesignContainer,
  OverviewCountdownTemplatesContainer,
  OverviewDesignContainer,
} from "./styles";
import { useOpticsStore } from "../../../../../../stores/use-optics-store";
import { getCountdownTemplates } from "./countdown-templates";
import { useCountdownStore } from "../../../../../../stores/use-countdown-store";
import { MACRO_KEY } from "../../../../../defaults";

const getCountdownData = (template, hasData) => {
  const { title, text, linkText, icon, time, newTab, url, format, ...rest } =
    template;

  return hasData ? { ...rest } : template;
};

export const OverviewTemplates = () => {
  const { data, setData } = useCountdownStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));
  const { setDrawers, styleguideSetup, setMacro, colorPalette } =
    useOpticsStore((state) => ({
      setDrawers: state.setDrawers,
      styleguideSetup: state.styleguideSetup,
      setMacro: state.setMacro,
      colorPalette: state.colorPalette,
    }));
  const hasData = Object.keys(data || {}).length;

  const templates = useMemo(
    () =>
      getCountdownTemplates({
        cornerRadius: styleguideSetup.cornerRadius,
        selectedColors: colorPalette,
        isInOverview: true,
      }),
    [styleguideSetup, colorPalette]
  );

  return (
    <OverviewCountdownTemplatesContainer>
      {templates.map((template) => (
        <OverviewDesignContainer
          borderRadius={styleguideSetup.cornerRadius}
          isSelected={data.id === template.id}
          key={template.id}
          hasHover
          onClick={() => {
            setData(getCountdownData(template, hasData));
            setMacro({ key: MACRO_KEY.COUNTDOWN });
            setDrawers({ templates: false, settings: true });
          }}
        >
          <Design data={template} isEditable={false} viewMode="edit" />
        </OverviewDesignContainer>
      ))}
    </OverviewCountdownTemplatesContainer>
  );
};

const CountdownTemplates = () => {
  const { data, setData } = useCountdownStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));
  const { setDrawers, styleguideSetup, colorPalette } = useOpticsStore(
    (state) => ({
      setDrawers: state.setDrawers,
      styleguideSetup: state.styleguideSetup,
      colorPalette: state.colorPalette,
    })
  );
  const hasData = Object.keys(data || {}).length;

  const templates = useMemo(
    () =>
      getCountdownTemplates({
        cornerRadius: styleguideSetup.cornerRadius,
        selectedColors: colorPalette,
      }),
    [styleguideSetup, colorPalette]
  );

  return (
    <CountdownTemplatesContainer>
      {templates.map((template) => (
        <DesignContainer
          isSelected={data.id === template.id}
          key={template.id}
          onClick={() => {
            setData(getCountdownData(template, hasData));
            setDrawers({ templates: false, settings: true });
          }}
        >
          <Design data={template} isEditable={false} viewMode="edit" />
        </DesignContainer>
      ))}
    </CountdownTemplatesContainer>
  );
};

export default CountdownTemplates;
